import phoneIcon from "../images/footer/icons/01.png"
import emailIcon from "../images/footer/icons/02.png"
import locationIcon from "../images/footer/icons/03.png"
export const footerInfo =[
    {
      img:phoneIcon ,
      alt: "Phone-icon",
      text: "رقم الاتصال : +88019 339 702 520"
    },
    {
      img: emailIcon,
      alt: "email-icon",
      text: "البريد الالكتروني: admin@تورولاف.com"
    },
    {
      img: locationIcon,
      alt: "location-icon",
      text: "العنوان: 30 شمال مغرب نیویارك 240."
    }
  ]